export default {
    primary: '#D6156B',
    'primary-tint': '#FFF0F6',
    'primary-line': '#FFC2DC',
    secondary: '#4E4A63',
    accent: '#FF9A3D',

    background: '#EDEDF2',
    surface: '#FFFFFF',
    'surface-2': '#FAFAFC',
    menus: '#FFFFFF',
    border: '#E7E7EF',
    'border-str': '#D6D6E3',

    text: '#14121F',
    'text-muted': '#5A5670',
    'text-subtle': '#8B87A3',

    ai: '#C43E1F',
    'ai-deep': '#A8320F',
    'ai-tint': '#FFF1EC',
    'ai-line': '#FFC9B8',

    error: '#D32F4A',
    info: '#2563EB',
    success: '#0C7F57',
    warning: '#A85C08',

    black: '#14121F',
    light: '#FFFFFF',
    neutral: '#34313F',
}
